/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Support_TextInputs */



/**
* | output |
* | --- |
* | "Please contact support if you have any issues: support@closedcaptioncreator.com" |
*
* @param {Login_Support_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_support_text = /** @type {((inputs?: Login_Support_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Support_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez contacter le support si vous rencontrez des problèmes : support@closedcaptioncreator.com")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei Problemen wenden Sie sich bitte an den Support: support@closedcaptioncreator.com")
	if (locale === "it") return /** @type {LocalizedString} */ ("In caso di problemi, contattare l'assistenza: support@closedcaptioncreator.com")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В случае возникновения проблем, пожалуйста, свяжитесь со службой поддержки по адресу: support@closedcaptioncreator.com")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comuníquese con el soporte si tiene algún problema: support@closedcaptioncreator.com")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如有任何问题，请联系客服：support@closedcaptioncreator.com")
	if (locale === "ja") return /** @type {LocalizedString} */ ("何か問題がございましたら、サポートまでご連絡ください: support@closedcaptioncreator.com")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यदि आपको कोई समस्या हो तो कृपया सहायता टीम से संपर्क करें: support@closedcaptioncreator.com")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caso tenha algum problema, entre em contato com o suporte: support@closedcaptioncreator.com")
	return /** @type {LocalizedString} */ ("Please contact support if you have any issues: support@closedcaptioncreator.com")
});